
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import apiUrl from "../../environment/Api";
import "../../assets/css/AttendanceReport.css";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import jsPDF from "jspdf";

function AttendanceReport() {
  const { id } = useParams();
  const [filtered, setFiltered] = useState([]);
  const [studentAttendance, setStudentAttendance] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("staff");
  const [activestudent, setactivestudent] = useState("student")
  const [searchTermStaff, setSearchTermStaff] = useState("");
  const [searchTermStudent, setSearchTermStudent] = useState("");
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [branch, setbranch] = useState([])
  const [Branches, setselectBranch] = useState([])
  const [loading, setLoading] = useState(false)


  const [selectedstaff, setselectedstaff] = useState([]);
  const [selectedstudent, setselectedstudent] = useState([]);

  const [uniquefilterdata, setuniquefilterdata] = useState([]);

  const [student_filtereduniqueData, setstudent_filtereduniqueData] = useState([]);


  // hndle branch change
  const handleBranchChange = (event) => {
    setselectBranch(event.target.value);
    setCurrentPage(1);

    console.log("The selected branch in handleBranchChange is : ", event.target.value);
    console.log("The selected branch == '' in handleBranchChange is : ", event.target.value == "");

    if (event.target.value == "") {
      // =========== code for staff data ==================
      const filtereduniqueData = filtered.reduce((acc, item) => {
        if (!acc.some((obj) => obj.empid === item.empid)) {
          acc.push(item);
        }
        return acc;
      }, []);

      setuniquefilterdata(filtereduniqueData);
      // =========== code for staff data ==================

      // =========== code for student data ==================
      const student_filtereduniqueData = studentAttendance.reduce((acc, item) => {
        if (!acc.some((obj) => obj.roll_no === item.roll_no)) {
          acc.push(item);
        }
        return acc;
      }, []);

      setstudent_filtereduniqueData(student_filtereduniqueData);
      // =========== code for student data ==================

    }
    else {
      // =========== code for staff data ==================
      let filtereduniqueData = filtered.filter(
        (item) => item.branch_id?.branch_name.trim().toLowerCase() === event.target.value.trim().toLowerCase()
      );

      filtereduniqueData = filtereduniqueData.reduce((acc, item) => {
        if (!acc.some((obj) => obj.empid === item.empid)) {
          acc.push(item);
        }
        return acc;
      }, []);

      setuniquefilterdata(filtereduniqueData);
      // =========== code for staff data ==================

      // =========== code for student data ==================
      let student_filtereduniqueData = studentAttendance.filter(
        (item) => item.branch_id?.branch_name.trim().toLowerCase() === event.target.value.trim().toLowerCase()
      );

      student_filtereduniqueData = student_filtereduniqueData.reduce((acc, item) => {
        if (!acc.some((obj) => obj.roll_no === item.roll_no)) {
          acc.push(item);
        }
        return acc;
      }, []);

      setstudent_filtereduniqueData(student_filtereduniqueData);

      // =========== code for student data ==================
    }
  };

  // Handle tab switching
  const handleTabClick = (value) => {
    setActiveTab(value);
  };

  // Handle search input changes for staff
  const handleSearchChangeStaff = (e) => {
    setSearchTermStaff(e.target.value);

  };

  // Handle search input changes for student
  const handleSearchChangeStudent = (e) => {
    setSearchTermStudent(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const leadsResponse = await axios.get(apiUrl + "/attendance_overall");
        setFiltered(leadsResponse.data);

        const filtereduniqueData = leadsResponse.data.reduce((acc, item) => {
          if (!acc.some((obj) => obj.empid === item.empid)) {
            acc.push(item);
          }
          return acc;
        }, []);

        setuniquefilterdata(filtereduniqueData);  // code to store the unique data in another list

        // console.log("the filtereduniqueData in fetch data is : ",filtereduniqueData);


        const branchresponse = await axios.get(apiUrl + "/branch");

        console.log("Branch response:", branchresponse.data);


        if (Array.isArray(branchresponse.data)) {
          setbranch(branchresponse.data);
        } else {
          console.error("Unexpected data format:", branchresponse.data);
        }



        const uniqueStatuses = Array.from(
          new Set(leadsResponse.data.map((item) => item.followups_status))
        ).map((status) => ({ followups_status: status }));

        setStatuses(uniqueStatuses);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setTimeout(
        () => {
          setLoading(false)
        }, 500
      )

    };

    fetchData();
  }, [id]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const leadsResponse = await axios.get(
          apiUrl + "/student_dairy_overall"
        );
        setStudentAttendance(leadsResponse.data);

        const student_filtereduniqueData = leadsResponse.data.reduce((acc, item) => {
          if (!acc.some((obj) => obj.roll_no === item.roll_no)) {
            acc.push(item);
          }
          return acc;
        }, []);

        // console.log("The student_filtereduniqueData in the fetch data function is : ",student_filtereduniqueData);

        setstudent_filtereduniqueData(student_filtereduniqueData);

        const uniqueStatuses = Array.from(
          new Set(leadsResponse.data.map((item) => item.followups_status))
        ).map((status) => ({ followups_status: status }));

        setStatuses(uniqueStatuses);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // code to calculate railway time to normal time
  const railwayToNormalTime = (railwayTime) => {
    if (!railwayTime) return "";
    const [hour, minute] = railwayTime.split(":");
    const parsedHour = parseInt(hour);
    const parsedMinute = parseInt(minute);

    // if (parsedHour < 12) {
    //   return `${parsedHour}:${minute} AM`;
    // } else if (parsedHour === 12) {
    //   return `${parsedHour}:${minute} PM`;
    // } else {
    //   return `${parsedHour - 12}:${minute} PM`;
    // }

    if (parsedHour < 12) {
      return `${parsedHour}:${minute}`;
    } else if (parsedHour === 12) {
      return `${parsedHour}:${minute}`;
    } else {
      return `${parsedHour - 12}:${minute}`;
    }
  };

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

  // const filteredData = filtered.filter((item) => {
  const filteredData = filtered.filter((item) => {
    const isCourseMatch = selectedCourse
      ? item.Prefered_course === selectedCourse
      : true;


    const isBranchMatch = Branches
      ? item.branch_id?.branch_name === Branches
      : true;

    const isStatusMatch = selectedStatus
      ? item.followups_status === selectedStatus
      : true;

    const itemEnquiryDate = new Date(item.date);
    const isFromDateMatch = fromDate
      ? itemEnquiryDate >= new Date(fromDate)
      : true;
    const isToDateMatch = toDate ? itemEnquiryDate <= new Date(toDate) : true;

    const isSearchMatch = searchTerm
      ? (item.empid &&
        item.empid.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.empid &&
        item.empid.toUpperCase().includes(searchTerm.toUpperCase())) ||
      (item.mobile_no && String(item.mobile_no).includes(searchTerm)) ||
      (item.name &&
        item.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.name &&
        item.name.toUpperCase().includes(searchTerm.toUpperCase())) ||
      item.branch_id?.branch_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.branch_id.branch_name &&
        item.branch_id.branch_name
          .toLowerCase()
          .includes(searchTerm.toLowerCase())) ||
      (item.branch_id.branch_name &&
        item.branch_id.branch_name
          .toUpperCase()
          .includes(searchTerm.toUpperCase())) ||
      (item.workhour &&
        item.workhour.toUpperCase().includes(searchTerm.toUpperCase())) ||
      (item.overtime &&
        item.overtime.toUpperCase().includes(searchTerm.toUpperCase())) ||
      (railwayToNormalTime(item.login) &&
        railwayToNormalTime(item.login).toUpperCase().includes(searchTerm.toUpperCase())) ||
      (railwayToNormalTime(item.logout) &&
        railwayToNormalTime(item.logout).toUpperCase().includes(searchTerm.toUpperCase()))
      : true;

    // code to filter the data based on the selected staff
    const isStaffMatch = selectedstaff
      ? item.empid === selectedstaff
      : true;

    return (
      isCourseMatch &&
      isStatusMatch &&
      isBranchMatch &&
      isFromDateMatch &&
      isToDateMatch &&
      isSearchMatch &&
      isStaffMatch
    );
  });

  // const currentEntries = filteredData.slice(
  let currentEntries = filteredData.slice(
    indexOfFirstEntry,
    indexOfLastEntry
  );

  // filter code for student data
  const student_filteredData = studentAttendance.filter((item) => {
    const isCourseMatch = selectedCourse
      ? item.Prefered_course === selectedCourse
      : true;

    const isBranchMatch = Branches
      ? item.branch_id?.branch_name === Branches
      : true;

    const isStatusMatch = selectedStatus
      ? item.followups_status === selectedStatus
      : true;

    const itemEnquiryDate = new Date(item.date);
    const isFromDateMatch = fromDate
      ? itemEnquiryDate >= new Date(fromDate)
      : true;
    const isToDateMatch = toDate ? itemEnquiryDate <= new Date(toDate) : true;

    const isSearchMatch = searchTerm
      ? (item.roll_no &&
        item.roll_no.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.course &&
        item.course.toUpperCase().includes(searchTerm.toUpperCase())) ||
      // (item.mobile_no && String(item.mobile_no).includes(searchTerm)) ||
      (item.student &&
        item.student.toLowerCase().includes(searchTerm.toLowerCase())) ||
      // (item.name &&
      //   item.name.toUpperCase().includes(searchTerm.toUpperCase())) ||
      (item.login && String(item.login).includes(searchTerm)) ||
      (item.logout && String(item.logout).includes(searchTerm)) ||
      item.branch_id?.branch_name?.toLowerCase().includes(searchTerm.toLowerCase())
      // (item.branch_id.branch_name &&
      //   item.branch_id.branch_name
      //     .toLowerCase()
      //     .includes(searchTerm.toLowerCase())) ||
      // (item.branch_id.branch_name &&
      //   item.branch_id.branch_name
      //     .toUpperCase()
      //     .includes(searchTerm.toUpperCase()))
      : true;

    // code to filter the data based on the selected staff
    const isStudentMatch = selectedstudent
      ? item.roll_no === selectedstudent
      : true;

    return (
      isCourseMatch &&
      isStatusMatch &&
      isBranchMatch &&
      isFromDateMatch &&
      isToDateMatch &&
      isSearchMatch &&
      isStudentMatch
    );
  });

  // const currentEntry = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);  //don't remove it
  const currentEntry = student_filteredData.slice(indexOfFirstEntry, indexOfLastEntry);
  // const currentEntry = studentAttendance.slice(indexOfFirstEntry, indexOfLastEntry);

  const handleEntriesPerPageChange = (event) => {
    setEntriesPerPage(Number(event.target.value));
    setCurrentPage(1); // Reset to the first page when entries per page changes
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setSelectedCourse("");
    setSelectedStatus("");
    setFromDate("");
    setselectBranch("");
    setToDate("");
    setSearchTerm("");
    setCurrentPage(1);
    setselectedstaff(""); // code to clear the staff filter
    setselectedstudent(""); //code to clear the student filter
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  // this is the first code we use
  // const railwayToNormalTime = (railwayTime) => {
  //   if (!railwayTime) return "";
  //   const [hour, minute] = railwayTime.split(":");
  //   const parsedHour = parseInt(hour);
  //   const parsedMinute = parseInt(minute);
  //   if (parsedHour < 12) {
  //     return `${parsedHour}:${minute} AM`;
  //   } else if (parsedHour === 12) {
  //     return `${parsedHour}:${minute} PM`;
  //   } else {
  //     return `${parsedHour - 12}:${minute} PM`;
  //   }
  // };

  const handleCopy = () => {
    const tableElement = document.getElementById("tableId");
    const stu_tableElement = document.getElementById("stu_tableId");

    if (activeTab === "staff") {
      if (tableElement) {
        const tableData = tableElement.innerText;
        navigator.clipboard
          .writeText(tableData)
          .then(() => {
            alert("Attendance data copied to clipboard!");
          })
          .catch((err) => {
            console.error("Failed to copy text: ", err);
          });
      } else {
        console.error("Table with ID 'tableId' not found");
      }
    }
    else if (activeTab === "student") {
      if (stu_tableElement) {
        const tableData = stu_tableElement.innerText;
        navigator.clipboard
          .writeText(tableData)
          .then(() => {
            alert("Attendance data copied to clipboard!");
          })
          .catch((err) => {
            console.error("Failed to copy text: ", err);
          });
      } else {
        console.error("Table with ID 'tableId' not found");
      }
    }
    else {
      alert("something went wrong!");
    }

  };

  const handleCSVExport = () => {

    if (activeTab === "staff") {
      // Define CSV headers
      const csvHeaders = [
        "S.No",
        "Branch Name",
        "Employee ID",
        "Name",
        "Date",
        "Login Time",
        "Logout Time",
        "Work Hours",
        "Over Time"
      ];

      // Prepare CSV data
      const csvData = filteredData.map((item, index) => [
        index + 1, // Serial number
        item.branch_id ? item.branch_id.branch_name : "N/A", // Branch name, with fallback
        item.empid || "N/A", // Employee ID, with fallback
        item.name || "N/A", // Name, with fallback
        // new Date(item.date).toLocaleDateString(), // Format date
        formatDate(item.date), // Format date
        railwayToNormalTime(item.login || ""), // Convert login time
        railwayToNormalTime(item.logout || ""), // Convert logout time
        railwayToNormalTime(item.workhour || ""), // Convert work hours
        item.overtime || "N/A", // Convert overtime
      ]);

      // Generate CSV content
      const csvContent = [
        csvHeaders.join(","), // Headers
        ...csvData.map((row) => row.join(",")), // Data rows
      ].join("\n");

      // Create a Blob for CSV content and trigger download
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "attendance_report.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    else {
      // Define CSV headers
      const csvHeaders = [
        "S.No",
        "Branch",
        "Student",
        "Course",
        "Date",
        "Login Time",
        "Logout Time",
        "Total Hour",
      ];

      // Prepare CSV data
      const csvData = student_filteredData.map((item, index) => [
        index + 1, // Serial number
        item.branch_id ? item.branch_id.branch_name : "N/A", // Branch name, with fallback
        item.student || "N/A", // Employee ID, with fallback
        item.course || "N/A", // Name, with fallback
        // new Date(item.date).toLocaleDateString(), // Format date
        formatDate(item.date),
        railwayToNormalTime(item.login || ""), // Convert login time
        railwayToNormalTime(item.logout || ""), // Convert logout time
        item.totalhour || "N/A", // Convert work hours
      ]);

      // Generate CSV content
      const csvContent = [
        csvHeaders.join(","), // Headers
        ...csvData.map((row) => row.join(",")), // Data rows
      ].join("\n");

      // Create a Blob for CSV content and trigger download
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "attendance_report.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleExport = () => {
    if (activeTab === "staff") {
      const tableElement = document.getElementById("tableId");
      if (tableElement) {
        const worksheet = XLSX.utils.table_to_sheet(tableElement);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "Attendance_Staff_Report.xlsx");
      } else {
        console.error(
          "Table with ID 'tableId' not found. Check if the table is rendered in the DOM."
        );
      }
    }
    else if (activeTab === "student") {
      const tableElement = document.getElementById("stu_tableId");
      if (tableElement) {
        const worksheet = XLSX.utils.table_to_sheet(tableElement);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "Attendance_Student_Report.xlsx");
      } else {
        console.error(
          "Table with ID 'stu_tableId' not found. Check if the table is rendered in the DOM."
        );
      }
    }
    else {
      alert("Something went wrong!");
    }

  };



  // const handleGeneratePDF = () => {
  //   let tableElement, tablerowElement, fileName;
  
  //   if (activeTab === "staff") {
  //     tableElement = document.getElementById("tableId");
  //     tablerowElement = document.getElementById("table_total_hours");
  //     fileName = "Attendance_Report.pdf";
  //   } else if (activeTab === "student") {
  //     tableElement = document.getElementById("stu_tableId");
  //     tablerowElement = document.getElementById("student_table_total_hours");
  //     fileName = "attendance_report.pdf";
  //   } else {
  //     alert("Something went wrong!");
  //     return;
  //   }
  
  //   if (!tableElement || !tablerowElement) {
  //     console.error("Table not found");
  //     return;
  //   }
  
  //   html2canvas(tableElement, { scale: 2, useCORS: true }).then((canvas1) => {
  //     html2canvas(tablerowElement, { scale: 2, useCORS: true }).then((canvas2) => {
  //       const pdf = new jsPDF();
  //       const pageWidth = pdf.internal.pageSize.width;
  //       const pageHeight = pdf.internal.pageSize.height;
  //       const imgWidth = 190; // Fixed width for the image
  //       const imgHeight1 = (canvas1.height * imgWidth) / canvas1.width;
  //       const imgHeight2 = (canvas2.height * imgWidth) / canvas2.width;
  
  //       let positionY = 10;
  //       let remainingHeight = imgHeight1;
  //       let sourceY = 0;
  
  //       while (remainingHeight > 0) {
  //         const cropHeight = Math.min(pageHeight - 20, remainingHeight);
  
  //         const pageCanvas = document.createElement("canvas");
  //         pageCanvas.width = canvas1.width;
  //         pageCanvas.height = cropHeight * (canvas1.width / imgWidth);
  //         const pageCtx = pageCanvas.getContext("2d");
  
  //         pageCtx.drawImage(
  //           canvas1,
  //           0, sourceY, canvas1.width, pageCanvas.height, // Crop source
  //           0, 0, pageCanvas.width, pageCanvas.height // Destination
  //         );
  
  //         const croppedImg = pageCanvas.toDataURL("image/png");
  //         pdf.addImage(croppedImg, "PNG", 10, positionY, imgWidth, cropHeight);
  
  //         remainingHeight -= cropHeight;
  //         sourceY += pageCanvas.height;
  
  //         if (remainingHeight > 0) {
  //           pdf.addPage();
  //         }
  //       }
  
  //       positionY += 10;
  
  //       // Check if total hours table fits on the same page
  //       if (positionY + imgHeight2 > pageHeight) {
  //         pdf.addPage();
  //         positionY = 10;
  //       }
  
  //       pdf.addImage(canvas2.toDataURL("image/png"), "PNG", 10, positionY, imgWidth, imgHeight2);
  
  //       pdf.save(fileName);
  //     });
  //   }).catch((error) => {
  //     console.error("Error generating PDF: ", error);
  //   });
  // };



 const handleGeneratePDF = () => {
  let tableElement, fileName, title;

  if (activeTab === "staff") {
    tableElement = document.getElementById("tableId");
    fileName = "Attendance_Report.pdf";
    title = "Attendance Report";
  } else if (activeTab === "student") {
    tableElement = document.getElementById("stu_tableId");
    fileName = "Student_Attendance_Report.pdf";
    title = "Student Attendance Report";
  } else {
    alert("Something went wrong!");
    return;
  }

  if (!tableElement) {
    console.error("Table not found");
    return;
  }

  html2canvas(tableElement, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL("image/jpeg", 0.95);
    const pdf = new jsPDF();

    const pageWidth = pdf.internal.pageSize.width;
    const pageHeight = pdf.internal.pageSize.height;
    const imgWidth = pageWidth - 20;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.setFontSize(18);
    pdf.setFont("helvetica", "bold");
    pdf.text(title, pageWidth / 2, 15, { align: "center" });

    let positionY = 25;

    if (imgHeight <= pageHeight - 30) {
      pdf.addImage(imgData, "JPEG", 10, positionY, imgWidth, imgHeight);
    } else {
      let remainingHeight = imgHeight;
      let sourceY = 0;
      let pageNumber = 1;

      while (remainingHeight > 0) {
        const cropHeight = Math.min(pageHeight - 40, remainingHeight);
        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = canvas.width;
        pageCanvas.height = Math.floor(cropHeight * (canvas.width / imgWidth));
        const pageCtx = pageCanvas.getContext("2d");

        pageCtx.drawImage(
          canvas,
          0, sourceY, canvas.width, pageCanvas.height,
          0, 0, pageCanvas.width, pageCanvas.height
        );

        const croppedImg = pageCanvas.toDataURL("image/jpeg", 0.95);
        pdf.addImage(croppedImg, "JPEG", 10, positionY, imgWidth, cropHeight);

        remainingHeight -= cropHeight;
        sourceY += pageCanvas.height;

        if (remainingHeight > 0) {
          pdf.addPage();
          pageNumber++;
          positionY = 10;
          pdf.setFontSize(12);
          pdf.text(`Page ${pageNumber}`, pageWidth - 20, pageHeight - 10);
        }
      }
    }

    pdf.save(fileName);
  }).catch((error) => {
    console.error("Error generating PDF: ", error);
  });
};

  
  
  const handlePrint = () => {
    if (activeTab === "staff") {
      const tableElement = document.getElementById("tableId");
      const tablerowElement = document.getElementById("table_total_hours");
      if (tableElement) {
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
            <html>
              <head>
                <title>Print Attendance Table</title>
                <style>
                  body { font-family: Arial, sans-serif; }
                  table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                  th, td { border: 1px solid #000; padding: 8px; text-align: left; }
                  th { background-color: #f2f2f2; }

                  /* Ensuring row structure remains intact */
                            .row { display: flex; flex-wrap: wrap; margin-top: 10px; }
                            .col-lg-9 { flex: 0 0 75%; max-width: 75%; }
                            .col-lg-3 { flex: 0 0 25%; max-width: 25%; }
                            .col-lg-6 { flex: 0 0 50%; max-width: 50%; text-align: center; font-weight: bold; }
                            
                            /* Page break handling for print */
                            @media print {
                                .row { page-break-inside: avoid; }
                                table { page-break-inside: auto; }
                            }
                </style>
              </head>
              <body>
                <h1 style="text-align: center;">Attendance Report</h1>
                <div>${tableElement.outerHTML}</div>

              <div class="row">
                <div class="col-lg-9"></div>
                <div class="col-lg-3">
                  <div class="row">
                    <div class="col-lg-6">Total Hours :  ${total_workhour}</div>
                    <div class="col-lg-6">${total_overtime}</div>
                  </div>
                </div>
              </div>
                
              </body>
            </html>
          `);
        printWindow.document.close();
        printWindow.onload = () => {
          printWindow.focus();
          printWindow.print();
          printWindow.onafterprint = () => {
            printWindow.close();
          };
        };
      } else {
        console.error("Table with ID 'tableId' not found");
      }
    }
    else if (activeTab === "student") {
      const tableElement = document.getElementById("stu_tableId");
      const tablerowElement = document.getElementById("table_total_hours");
      if (tableElement) {
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
          <html>
            <head>
              <title>Print Attendance Table</title>
              <style>
                body { font-family: Arial, sans-serif; }
                table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                th, td { border: 1px solid #000; padding: 8px; text-align: left; }
                th { background-color: #f2f2f2; }

                /* Ensuring row structure remains intact */
                          .row { display: flex; flex-wrap: wrap; margin-top: 10px; }
                          .col-lg-9 { flex: 0 0 75%; max-width: 75%; }
                          .col-lg-3 { flex: 0 0 25%; max-width: 25%; }
                          .col-lg-6 { flex: 0 0 50%; max-width: 50%; text-align: center; font-weight: bold; }
                          
                          /* Page break handling for print */
                          @media print {
                              .row { page-break-inside: avoid; }
                              table { page-break-inside: auto; }
                          }
              </style>
            </head>
            <body>
              <h1 style="text-align: center;">Attendance Report</h1>
              <div>${tableElement.outerHTML}</div>

            <div class="row">
              <div class="col-lg-9"></div>
              <div class="col-lg-3">
                <div class="row">
                  <div class="col-lg-6">Total Hours : </div>
                  <div class="col-lg-6">${std_totalhour}</div>
                </div>
              </div>
            </div>
              
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.onload = () => {
          printWindow.focus();
          printWindow.print();
          printWindow.onafterprint = () => {
            printWindow.close();
          };
        };
      } else {
        console.error("Table with ID 'tableId' not found");
      }
    }
  };
  // ============================= the role and previliges=======================



  useEffect(() => {
    gettoken();
    getprevillages();
  }, []);


  const gettoken = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);

      setroleid(response.data.detail.rolename);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      if (id) { }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);
    const total_previlages = username.modules;
    const new_enquiry = total_previlages.find((item) => item.name == "Attendance Report")
    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions)
  }





  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  const createPagination = () => {
    let liTag = [];
    let beforePage = currentPage - 1;
    let afterPage = currentPage + 1;
    let active;

    if (currentPage > 1) {
      liTag.push(
        <li className="page-item" key="prev">
          <button
            className="page-link"
            onClick={() => paginate(currentPage - 1)}
          >
            <FaAngleLeft /> Prev
          </button>
        </li>
      );
    }

    if (currentPage > 2) {
      liTag.push(
        <li className="page-item" key="first" onClick={() => paginate(1)}>
          <button className="page-link">1</button>
        </li>
      );
      if (currentPage > 3) {
        liTag.push(
          <li className="page-item disabled" key="dots1">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    if (currentPage === totalPages) {
      beforePage -= 2;
    } else if (currentPage === totalPages - 1) {
      beforePage -= 1;
    }

    if (currentPage === 1) {
      afterPage += 2;
    } else if (currentPage === 2) {
      afterPage += 1;
    }

    for (let plength = beforePage; plength <= afterPage; plength++) {
      if (plength > totalPages || plength <= 0) continue;
      active = currentPage === plength ? "active" : "";
      liTag.push(
        <li
          className={`page-item ${active}`}
          key={plength}
          onClick={() => paginate(plength)}
        >
          <button className="page-link">{plength}</button>
        </li>
      );
    }

    if (currentPage < totalPages - 1) {
      if (currentPage < totalPages - 2) {
        liTag.push(
          <li className="page-item disabled" key="dots2">
            <span className="page-link">...</span>
          </li>
        );
      }
      liTag.push(
        <li
          className="page-item"
          key="last"
          onClick={() => paginate(totalPages)}
        >
          <button className="page-link">{totalPages}</button>
        </li>
      );
    }

    if (currentPage < totalPages) {
      liTag.push(
        <li className="page-item" key="next">
          <button
            className="page-link"
            onClick={() => paginate(currentPage + 1)}
          >
            Next <FaAngleRight />
          </button>
        </li>
      );
    }

    return liTag;
  };


  // =========== code to fetch the data at initially ================
  useEffect(() => {
    handleClearFilters();
  }, []);
  // =========== code to fetch the data at initially ================


  // =========== code to calculate the total workhour totla overtime ================
  const [total_workhour, settotal_workhour] = useState("0:00");
  const [total_overtime, settotal_overtime] = useState("0:00");

  const [std_totalhour, set_std_totalhour] = useState("0:00");

  // code to calculate the total work hour
  const sumWorkHours = () => {
    if (!currentEntries || currentEntries.length === 0) {
      console.log("No data in currentEntries");
      settotal_workhour("0:00");
      return;
    }

    let totalMinutes = 0;

    currentEntries.forEach((item, index) => {
      if (!item.workhour || typeof item.workhour !== "string") {
        console.log(`Invalid workhour at index ${index}:`, item.workhour);
        return;
      }

      // Normalize format: replace '.' with ':' if needed
      let workhour = item.workhour.replace(".", ":");

      const timeParts = item.workhour.split(":");

      if (timeParts.length !== 2) {
        console.log(`Incorrect format at index ${index}:`, item.workhour);
        return;
      }

      const [hours, minutes] = timeParts.map(Number);

      if (isNaN(hours) || isNaN(minutes)) {
        console.log(`NaN detected at index ${index}:`, item.workhour);
        return;
      }

      totalMinutes += hours * 60 + minutes;
    });

    // Convert total minutes back to hours and minutes
    const totalHours = Math.floor(totalMinutes / 60);
    const totalMins = totalMinutes % 60;

    const total_workhour = `${totalHours}:${totalMins.toString().padStart(2, "0")}`;

    console.log("The total_workhour is:", total_workhour);

    settotal_workhour(total_workhour);
  };


  // code to calculate the total work hour
  const sumWorkOverTime = () => {
    if (!currentEntries || currentEntries.length === 0) {
      console.log("No data in currentEntries");
      settotal_overtime("0:00");
      return;
    }

    let totalMinutes = 0;

    currentEntries.forEach((item, index) => {
      if (!item.overtime || typeof item.overtime !== "string") {
        console.log(`Invalid overtime at index ${index}:`, item.overtime);
        return;
      }

      // Normalize format: replace '.' with ':' if needed
      let overtime = item.overtime.replace(".", ":");

      const timeParts = item.overtime.split(":");

      if (timeParts.length !== 2) {
        console.log(`Incorrect format at index ${index}:`, item.overtime);
        return;
      }

      const [hours, minutes] = timeParts.map(Number);

      if (isNaN(hours) || isNaN(minutes)) {
        console.log(`NaN detected at index ${index}:`, item.overtime);
        return;
      }

      totalMinutes += hours * 60 + minutes;
    });

    // Convert total minutes back to hours and minutes
    const totalHours = Math.floor(totalMinutes / 60);
    const totalMins = totalMinutes % 60;

    const total_overtime = `${totalHours}:${totalMins.toString().padStart(2, "0")}`;

    console.log("The total_overtime is:", total_overtime);

    settotal_overtime(total_overtime);
  };


  useEffect(() => {
    if (currentEntries && currentEntries.length > 0) {
      console.log("the currentEntries in attendance report page is : ", currentEntries);
      sumWorkHours();
      sumWorkOverTime();
    } else {
      // If no entries match the search, set totalAmount to 0
      sumWorkHours(0);
      sumWorkOverTime(0);
    }
  }, [currentEntries]);


  // code to calculate the total work hour
  const sumstd_totalhour = () => {
    if (!currentEntry || currentEntry.length === 0) {
      console.log("No data in currentEntry");
      return;
    }

    let totalMinutes = 0;

    currentEntry.forEach((item, index) => {
      if (!item.totalhour || typeof item.totalhour !== "string") {
        console.log(`Invalid workhour at index ${index}:`, item.totalhour);
        return;
      }

      // Normalize format: replace '.' with ':' if needed
      let totalhour = item.totalhour.replace(".", ":");

      const timeParts = item.totalhour.split(":");

      if (timeParts.length !== 2) {
        console.log(`Incorrect format at index ${index}:`, item.totalhour);
        return;
      }

      const [hours, minutes] = timeParts.map(Number);

      if (isNaN(hours) || isNaN(minutes)) {
        console.log(`NaN detected at index ${index}:`, item.totalhour);
        return;
      }

      totalMinutes += hours * 60 + minutes;
    });

    // Convert total minutes back to hours and minutes
    const totalHours = Math.floor(totalMinutes / 60);
    const totalMins = totalMinutes % 60;

    const std_totalhour = `${totalHours}:${totalMins.toString().padStart(2, "0")}`;

    console.log("The std_totalhour is:", std_totalhour);

    set_std_totalhour(std_totalhour);
  };


  useEffect(() => {
    if (currentEntry && currentEntry.length > 0) {
      // console.log("the currentEntry in attendance report page is : ",currentEntry);
      sumstd_totalhour();
    }
  }, [currentEntry]);

  // =========== code to calculate the total workhour totla overtime ================


  // ========== code for staff dropdown select ===============

  // const [selectedstaff, setselectedstaff] = useState("");

  const setselectstaff = (staff_data) => {
    setselectedstaff(staff_data);
  }










  return (
    <>

      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="container-fluid mb-5">
        <div
          className="card p-2"
          style={{
            marginTop: "-80px",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
        >
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6 pt-2">
              <h6 style={{color:"#8f0505"}}>
                <b>Attendance Report</b>
              </h6>
            </div>

            <div className="col-lg-6 pt-2">
              <div className="row">
              <div className="col-lg-1"></div>
                <div className="col-lg-3" style={{textDecoration:'underline'}}><b>Total Hour</b></div>
                <div className="col-lg-3">{total_workhour}</div>
                <div className="col-lg-3"style={{textDecoration:'underline'}}><b>Over Time</b></div>
                <div className="col-lg-2">{total_overtime}</div>
              </div>
            </div>
          </div>
          <hr />
          <div className="row p-2">
            <div className="col-lg-2 col-md-3 col-sm-12 mx-3">
              <input
                type="date"
                value={fromDate}
                onChange={handleFromDateChange}
                className="form-control"
              />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-12">
              <input
                type="date"
                value={toDate}
                onChange={handleToDateChange}
                className="form-control"
              />
            </div>

            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={Branches} // Ensure this matches the state variable for the selected branch
                // onChange={(e) => setselectBranch(e.target.value)} // Update the state
                onChange={handleBranchChange}
                className="form-control"
              >
                {/* <option value="">Select branch</option> */}
                <option value="">All branches</option>
                {branch.map((branchItem) => (
                  <option key={branchItem._id} value={branchItem.branch_id?.branch_name}>
                    {branchItem.branch_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-6">
              <select
                className="form-select"
                value={activeTab}
                onChange={(e) => handleTabClick(e.target.value)}
              >
                <option value="staff">Staff</option>
                <option value="student">Student</option>
              </select>
            </div>

            {/* Search input field */}
            {/* <div className="col-lg-2 col-md-2 col-sm-6">
              <input
                type="text"
                className="form-control"
                placeholder={
                  activeTab === "staff" ? "Staff ID" : "Register No."
                }
                value={
                  activeTab === "staff" ? searchTermStaff : searchTermStudent
                }
                onChange={
                  activeTab === "staff"
                    ? handleSearchChangeStaff
                    : handleSearchChangeStudent
                }
                style={{
                  backgroundColor:
                    activeTab === "staff" ? "#f0f0f0" : "#e0e0e0", // Dull background for each tab
                }}
              />
            
            </div> */}

            {/* code for staff dropdown */}
            {activeTab === "staff" && (
              <div className="col-lg-2 col-md-3 col-sm-12">
                <select
                  value={selectedstaff} // Ensure this matches the state variable for the selected branch
                  onChange={(e) => setselectstaff(e.target.value)} // Update the state
                  className="form-control"
                >
                  {/* <option value="">Select branch</option> */}
                  <option value="">All Staffs</option>
                  {/* {filtered.map((staff_data) => (
                <option value={staff_data.empid}>
                  {staff_data.name}
                </option>
              ))} */}
                  {uniquefilterdata.map((staff_data) => (
                    <option value={staff_data.empid}>
                      {staff_data.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {activeTab === "student" && (
              <div className="col-lg-2 col-md-3 col-sm-12">
                <select
                  value={selectedstudent} // Ensure this matches the state variable for the selected branch
                  onChange={(e) => setselectedstudent(e.target.value)} // Update the state
                  className="form-control"
                >
                  {/* <option value="">Select branch</option> */}
                  <option value="">All Students</option>
                  {/* {studentAttendance.map((std_data) => ( */}
                  {student_filtereduniqueData.map((std_data) => (
                    <option value={std_data.roll_no}>
                      {std_data.student}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* ============= code for clear button ================================ */}
            <div className="col-lg-1 col-md-2 col-sm-12">
              <button className="btn btn-danger" onClick={handleClearFilters}>
                Clear
              </button>
            </div>
            {/* ============= code for clear button ================================ */}

            {/* <div className="col-lg-2 col-md-3 col-sm-12 d-flex align-items-end mx-3">
              <button
                className="btn border btn-danger"
                onClick={handleClearFilters}
              >
                <i className="fa-solid fa-xmark"></i> 
              </button>
            </div> */}

          </div>
          <hr></hr>

          <div className="container ">
            <div className="row">
              <div className="col-md-3 d-flex align-items-center">
                <p className="mb-0 mr-2">Show: </p>
                <select
                  value={entriesPerPage}
                  onChange={handleEntriesPerPageChange}
                  className="form-control mx-2"
                  style={{ width: "50px" }}
                >
                  {/* <option value={5}>5</option> */}
                  <option value={10}>10</option>
                  <option value={15}>20</option>
                  <option value={filteredData.length}>All</option>
                </select>
              </div>
              <div className="col-md-6">
                {previllages.download && (
                  <button
                    className="btn btn-secondary2 mx-2"
                    onClick={handleCopy}
                  >
                    Copy
                  </button>
                )}
                {previllages.download && (
                  <button
                    className="btn btn-success2 mx-2"
                    onClick={handleCSVExport}
                  >
                    CSV
                  </button>
                )}

                {previllages.download && (
                  <button className="btn btn-excel2 mx-2" onClick={handleExport}>
                    Excel
                  </button>
                )}

                {previllages.download && (
                  <button
                    className="btn btn-info2 mx-2"
                    onClick={handleGeneratePDF}
                  >
                    PDF
                  </button>
                )}
                {previllages.download && (
                  <button className="btn btn-warning2 mx-2" onClick={handlePrint}>
                    Print
                  </button>
                )}

              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <input
                  className="form-control border"
                  type="text"
                  placeholder="Search.."
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </div>
            </div>

            {activeTab === "staff" && (
              <table
                id="tableId"
                className="table mt-2 table-bordered table-striped"
              >
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Branch</th>
                    <th>Staff Id</th>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Log In</th>
                    <th>Log Out</th>
                    <th>Work Hour</th>
                    <th>OverTime</th>
                  </tr>
                </thead>
                <tbody>
                  {currentEntries.length > 0 ? (
                    currentEntries.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {index + 1 + (currentPage - 1) * entriesPerPage}
                        </td>
                        <td>
                          {item.branch_id ? item.branch_id.branch_name : "N/A"}
                        </td>
                        <td>{item.empid}</td>
                        <td>{item.name}</td>
                        <td>{formatDate(item.date)}</td>
                        <td>{railwayToNormalTime(item.login || "")}</td>
                        <td>{railwayToNormalTime(item.logout || "")}</td>
                        {/* <td>{railwayToNormalTime(item.workhour || "")}</td> */}
                        <td>{item.workhour} </td>
                        <td>{item.overtime ? item.overtime : "0:00"} </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {activeTab === "student" && (
              <table className="table mt-2 table-bordered table-striped" id="stu_tableId">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Branch</th>
                    <th>Student</th>
                    <th>Course</th>
                    <th>Date</th>
                    <th>Log In</th>
                    <th>Log Out</th>
                    <th>Total Hour</th>
                  </tr>
                </thead>
                <tbody>
                  {currentEntry.length > 0 ? (
                    currentEntry.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {index + 1 + (currentPage - 1) * entriesPerPage}
                        </td>
                        <td>
                          {item.branch_id ? item.branch_id.branch_name : "N/A"}
                        </td>

                        <td>{item.student}</td>
                        <td>{item.course}</td>
                        <td>{new Date(item.date).toLocaleDateString()}</td>
                        <td>{railwayToNormalTime(item.login || "")}</td>
                        <td>{railwayToNormalTime(item.logout || "")}</td>
                        <td>{item.totalhour ? item.totalhour : "0:00"} </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {activeTab === "staff" && (
              <div className="row" id="table_total_hours">
                <div className="col-lg-6"></div>
                <div className="col-lg-3" style={{ textAlign: 'right' }}>Total Hours : </div>
                <div className="col-lg-3">
                  <div className="row">
                    <div className="col-lg-6">{total_workhour}</div>
                    <div className="col-lg-6">{total_overtime}</div>
                  </div>
                </div>
              </div>
            )}


            {activeTab === "student" && (
              <div className="row" id="student_table_total_hours">
                <div className="col-lg-9"></div>
                <div className="col-lg-3">
                  <div className="row">
                    <div className="col-lg-6">Total Hours : </div>
                    <div className="col-lg-6">{std_totalhour}</div>
                  </div>
                </div>
              </div>
            )}

            {/* Pagination Controls */}
            <div className="row">
              <div className="mt-3 pb-5">
                <div className="row">
                  <div className="col-lg-7 col-sm-12 mt-1">
                    <span className="text-dark">
                      Page {currentPage} of {totalPages}
                    </span>
                  </div>
                  <div className="col-lg-5">
                    <nav>
                      <ul className="pagination justify-content-center">
                        {createPagination()}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AttendanceReport;

